// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maintenance-budget-request .accordion-connection .card .card-header button.btn {
  padding-left: 20px;
}
.maintenance-budget-request table.table-connect {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  display: block;
  margin-bottom: 2.4rem;
}
.maintenance-budget-request .table.table-connect {
  background-color: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
}
.maintenance-budget-request .table-connect .container {
  position: relative;
}
.maintenance-budget-request .table-connect td, .maintenance-budget-request .table-connect th {
  font-size: 1.28rem;
}
.maintenance-budget-request .table-connect td:last-child, .maintenance-budget-request .table-connect th:last-child {
  border-right: none;
}
.maintenance-budget-request .table.table-connect thead {
  background-color: #f7f7f7;
}
.maintenance-budget-request .table.table-connect tr:first-child td {
  border-top: 1px solid transparent;
}
.maintenance-budget-request .table.table-connect thead th {
  border-bottom: 1px solid #dee2e6;
}
.maintenance-budget-request .table.table-connect td:first-child {
  width: 5%;
}
.maintenance-budget-request .table.table-connect td:nth-child(2) {
  width: 15%;
}
.maintenance-budget-request .table.table-connect td:nth-child(3) {
  width: 10%;
}
.maintenance-budget-request .table.table-connect td:nth-child(4) {
  width: 10%;
}
.maintenance-budget-request .table.table-connect td:nth-child(5) {
  width: 10%;
}
.maintenance-budget-request .table.table-connect td:nth-child(6) {
  width: 10%;
}
.maintenance-budget-request .table.table-connect td:last-child {
  width: 1%;
  padding-left: 6px;
  padding-right: 6px;
}
.maintenance-budget-request .table.table-connect th {
  vertical-align: middle;
  padding: 8px 6px;
  text-align: center;
}
.maintenance-budget-request .table.table-connect td {
  padding: 12px 6px;
  text-align: center;
}
.maintenance-budget-request .total a {
  font-size: 1.12rem;
  color: #0078dc !important;
  cursor: pointer;
  display: block;
}
.maintenance-budget-request .total a:focus {
  outline: none;
}
.maintenance-budget-request .total {
  padding-top: 0;
  padding-bottom: 0;
  line-height: 1.3;
  white-space: nowrap;
}
.maintenance-budget-request .adjacent a {
  font-size: 1.12rem;
  color: #0078dc !important;
  cursor: pointer;
}
.maintenance-budget-request .adjacent {
  text-align: center;
}
.maintenance-budget-request th.adjacent {
  border-bottom: none !important;
  padding-bottom: 0;
  padding-top: 0;
}
.maintenance-budget-request th.adjacent-cost {
  padding-top: 0;
  padding-bottom: 6px;
  border-top: none;
}
.maintenance-budget-request .checkmark {
  top: unset;
  margin-top: -6px;
  cursor: pointer;
}
.maintenance-budget-request .container input:disabled ~ .checkmark {
  cursor: default;
}
.maintenance-budget-request {
  /* Hide the browser's default checkbox */
}
.maintenance-budget-request .container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.maintenance-budget-request {
  /* Create a custom checkbox */
}
.maintenance-budget-request .checkmark {
  position: absolute;
  height: 20px;
  width: 20px;
  border: 2px solid #d0d0d0;
  border-radius: 4px;
  left: 0;
}
.maintenance-budget-request {
  /* When the checkbox is checked, add a blue background */
}
.maintenance-budget-request .container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 2px solid #2196F3;
}
.maintenance-budget-request {
  /* Create the checkmark/indicator (hidden when not checked) */
}
.maintenance-budget-request .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.maintenance-budget-request {
  /* Show the checkmark when checked */
}
.maintenance-budget-request .container input:checked ~ .checkmark:after {
  display: block;
}
.maintenance-budget-request {
  /* Style the checkmark/indicator */
}
.maintenance-budget-request .container .checkmark:after {
  left: 6px;
  top: 0px;
  width: 5px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
